module.exports = __webpack_public_path__ + "img/Vip_Card_4.fe383c89.png";